import React from 'react';

// Rough placeholder badge (plan §5 "Icon fidelity") -- intentionally not pixel-tuned, meant to be
// hand-replaced later.
const FilePdfBadgeIcon = () => (
  <svg data-dc-tpl="212" width="64" height="64" viewBox="0 0 60 64" fill="none"
       aria-hidden="true">
    <path data-dc-tpl="213"
          d="M14 4h24l12 12v40a4 4 0 0 1-4 4H14a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4Z"
          fill="#fff" stroke="#07132B" stroke-width="2.5"
          stroke-linejoin="round"></path>
    <path data-dc-tpl="214" d="M38 4v8a4 4 0 0 0 4 4h8" fill="none"
          stroke="#07132B" stroke-width="2.5" stroke-linejoin="round"></path>
    <path data-dc-tpl="215" d="M18 18h14M18 25h22M18 32h22" stroke="#E5252A"
          stroke-width="2.5" stroke-linecap="round"></path>
    <rect data-dc-tpl="216" x="2" y="38" width="40" height="18" rx="6"
          fill="#E5252A" stroke="#07132B" stroke-width="2.5"></rect>
    <text data-dc-tpl="217" x="22" y="51.5" text-anchor="middle"
          font-family="Plus Jakarta Sans, sans-serif" font-size="11"
          font-weight="800" fill="#fff" letter-spacing=".5">PDF
    </text>
  </svg>
);

export default FilePdfBadgeIcon;
